<template>
  <div>
    <div id="item-holder">
      <div><input v-model="searchInput" placeholder="Pretraga"></div>
      <br>
      <table>
        <tr><th>id</th><th>naziv</th><th>boja</th><th>kategorija</th><th>podkategorija</th><th>akcija</th><th>cijena</th><th>Opcije</th></tr>
        <tr v-for="item in filteredList" :key="item.artikli_id">
          <td>{{item.artikli_id}}</td>
          <td>{{item.artikli_naziv}}</td>
          <td>{{item.artikli_boje}}</td>
          <td>{{item.kategorija_naziv}}</td>
          <td>{{item.podkat_naziv}}</td>
          <td>{{item.artikli_akcija}}</td>
          <td>{{item.artikli_donjacijena}}</td>
          <td><router-link :to="'/dZpnOaCcAR/izm/' + item.artikli_id"><span class="klk">izmijeni</span></router-link><span class="klk" @click="brisi(item.artikli_id)">izbrisi</span></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdminArtikli',
  components: {
  },
  data () {
    return {
      itemObject: [],
      searchInput: ''
    }
  },
  created () {
    this.loadItem()
  },
  methods: {
    async loadItem () {
      const response = await fetch('https://vndnamjestaj.me/kaoitemlist.php')
      const data = await response.json()
      this.itemObject = data
      this.itemObject.forEach(element => {
        const nzv = element.artikli_naziv ? ',' + element.artikli_naziv.replace(' ', ',') : ''
        const dblj = element.dobavljac_naziv ? ',' + element.dobavljac_naziv.replace(' ', ',') : ''
        const konkat = element.kategorija_tagovi + ',' + element.podkat_tagovi + nzv + dblj
        element.tagovi = konkat.toLowerCase()
      })
    },
    async brisi (id) {
      if (confirm('Brišemo artikal ID: ' + id + '?')) {
        // Save it!
        await fetch('https://vndnamjestaj.me/pero.php?id=' + id)
        this.loadItem()
      }
    }
  },
  computed: {
    filteredList () {
      if (this.searchInput !== '') {
        var nizs = this.searchInput.toLowerCase().split(' ')
        return this.itemObject.filter(post => {
          return nizs.every(v => post.tagovi.includes(v))
        })
      } else {
        return this.itemObject
      }
    }
  }
}
</script>

<style lang="scss" scoped>

th{
  text-align: center;
  height: 3vw;
}

input{
  width: 30vw;
  padding: 0.3vw;
}

#item-holder{
  width: 60vw;
  margin: 0px auto;
  padding-top: 3vw
}

table{
  width:100%;
  text-align: left;
  padding:0px 0px 50px;
}

td{
  padding: 0.5vw;
}

td span{
  position: relative;
  margin: 0px 30px;
  cursor: pointer;
}

td:first-child{
  width: 200px;
  text-align: center;
}

td:nth-child(2){
  width: 60px;
  text-align: center;
}

td:last-child{
  text-align: right;
  width: 100px;
}

tr:nth-child(odd){
  background-color: #f2f2f2;
}

tr:hover{
  background-color: #d2d2d2;
}

.klk{
  cursor: pointer;
}

.klk:active{
  color: #aaa;
}

</style>
